export default __webpack_public_path__ + "static/media/socialmedia.9ae66395.webp";